export const apiBaseUrl = 'https://stage.api.eyepax.info';
export const imageBaseUrl = 'https://stage.tmp.eyepax.info/Attachments/';
export const  JIRA_TICKET_URL = 'https://eyepax.atlassian.net/browse/';

/* TABLE CONFIG */
export const DEFAULT_ROWS_PER_PAGE = 100;
